
/**
 * Espera un minimo de tiempo para que una promesa se resuelva.
 * Útil para probar la latencia de la UI/X o para hacer que
 * el contenido no tenga layout shifts
 */
export const minWait = async (promises = [], minimumWaitTime = 1500) => {
  if (typeof promises === 'number') {
    return new Promise((res) => setTimeout(res, promises))
  }

  const multiplePromisesProvided = Array.isArray(promises)

  const arrayOfPromises = multiplePromisesProvided ? promises : [promises]

  const resolved = (
    await Promise.all([...arrayOfPromises, new Promise((resolve) => setTimeout(resolve, minimumWaitTime))])
  ).slice(0, arrayOfPromises.length)

  return multiplePromisesProvided ? resolved : resolved[0]
}
